(function () {
  'use strict';

  angular.module('app').service('ClientContactModalService', ClientContactModalService);

  ClientContactModalService.$inject = ['ModalService'];

  function ClientContactModalService(ModalService) {
    var service = {
      openClientContact: openClientContact,
    };

    return service;

    ////////////////

    function openClientContact(item, client, mode, fast, successCallback) {
      ModalService.showModal({
        templateUrl: './app/ajs/clients/client-contacts/modals/client-contact-detail-modal.html',
        controller: ClientContactDetaiModalCtrl,
        controllerAs: 'vm',
        inputs: {
          item: item,
          client: client,
          mode: mode,
          fast: fast,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        var preventModalClose = {
          backdrop: 'static',
          keyboard: false,
        };

        modal.element.modal(preventModalClose);
      });

      ClientContactDetaiModalCtrl.$inject = [
        '$element',
        'item',
        'client',
        'mode',
        'fast',
        'successCallback',
        'UtilService',
      ];
    }

    function ClientContactDetaiModalCtrl(
      $element,
      item,
      client,
      mode,
      fast,
      successCallback,
      UtilService
    ) {
      var vm = this;

      vm.UtilService = new UtilService(vm);

      vm.item = item;
      vm.client = client;
      vm.mode = mode;
      vm.fast = fast;

      vm.modalTitle = item.id ? 'CONTACT_DETAILS' : 'NEW_CONTACT';

      vm.onClientContactSaved = onClientContactSaved;
      vm.onClientContactCanceled = onClientContactCanceled;

      function onClientContactSaved(data) {
        $element.modal('hide'); // bootstrap fade
        successCallback(data);
      }

      function onClientContactCanceled() {
        $element.modal('hide'); // bootstrap fade
      }
    }
  }
})();
